/**
 * Checks if provided error is a HyperError
 *
 * @see https://dazn.link/ts-extending-error-issue
 */
var isHyperError = function (err) {
    return err instanceof Error && 'code' in err && 'status' in err;
};
export { isHyperError };
//# sourceMappingURL=isHyperError.js.map